jQuery( document ).ready(function() {
  jQuery('.tab').click( function(e) {
    var parent = jQuery(this).closest('.tab_container'),
        target = jQuery(this).attr('data-target');
    parent.find('[data-active="1"]').attr('data-active',0);
    parent.find('[data-set=' + target + ']').attr('data-active',1);
    parent.find('[data-target=' + target + ']').attr('data-active',1);
    console.log({parent});
    console.log({target});
    e.stopPropagation();
  });
});
